<template lang="html">
    <form @submit.prevent="submit()" class="form" >
        <div class="form__items">
            <label class="form-item required"><span class="form-item__label">Ваши ФИО</span>
                <div class="default-input">
                    <input v-model="name" v-keyboard.right.fio type="text" name="activate-card-name" required placeholder="Введите ФИО">
                </div>
            </label>
            <label class="form-item required"><span class="form-item__label">Телефон</span>
                <div class="default-input">
                    <input-phone v-model="phone" v-keyboard.right.phone required ></input-phone>
                </div>
            </label>
			<div class="form-item">
				<XInputCheckbox
					v-model="agreement"
					:text="`Даю своё <a href='${policyLink}' target='_blank'>согласие на обработку персональных данных ООО «РК-Сервис»</a>`"
					required
				/>
			</div>
        </div>
        <div class="form__bottom">
            <button type="submit" class="btn">Создать карту</button>
        </div>
    </form>

    <popup-block ref="successPopup" @close="cardData = {}" >
        <div class="popup__title">
            <h2 class="popup__title-title">Ваша карта клиента</h2>
        </div>
        <div class="client-card">
            <div class="client-card__image">
                <img :src="cardData.qrCodeSrc" loading="lazy" />
            </div>
            <div class="client-card__info">
                <span class="client-card__number">{{ cardData.cardNum }}</span>
                <!-- <div class="client-card__discount">
                    <span class="client-card__discount-label">ваша скидка</span>
                    <p class="client-card__discount-value">3%</p>
                </div> -->
                <div class="client-card__bot">
                    <span class="client-card__discount--short">{{ cardData.discountText }}</span>
                </div>
            </div>
        </div>
    </popup-block>
</template>

<script>
import useInitData from '../composables/useInitData';
import { ref } from 'vue';
import { virtualCardRegister } from '../api';
import XInputCheckbox from "@/components/inputs/XInputCheckbox.vue";

export default {
    name : 'VirtualCardRegister',
	components: {XInputCheckbox},
	props : {
		policyLink: String,
	},
    setup () {
        const initData = useInitData();
        const processed = ref(false);
        const successPopup = ref(null);
        const cardData = ref({});
        const name = ref('');
        const phone = ref('');
		const agreement = ref(false);
        const submit = () => {
	        if (!agreement.value) {
		        window.alert('Вы не дали согласие на обработку персональных данных')
		        return;
	        }
            if (processed.value) {
                return;
            }
            processed.value = true;
            let data = new FormData();
            data.append('name', name.value);
            data.append('phone', phone.value);
            virtualCardRegister(data).then(res => {
                processed.value = false;
                if (res.success) {
                    cardData.value = res;
                    successPopup.value.open();
                    initData.load();
                }
                if (res.message) {
                    alert(res.message);
                }
            });
        }

        return {
            cardData,
            submit,
            successPopup,
            name,
            phone,
	        agreement,
        };
    }
}
</script>
